import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import background from "../images/background.png";
import TrendContent from "./TrendContent";
import VotingContent from "./VotingContent";

const isActive = (item) => {
  const now = new Date();
  return now >= new Date(item.startTime) && now <= new Date(item.endTime);
};

const pillClasses = (active) =>
  active
    ? "bg-custom-blue text-white border-2 border-sky-400 shadow-accent"
    : "bg-violet-300/[0.15] text-brand-muted border-[1.5px] border-violet-300";

// TrendingPage solo decide qué UI mostrar (TrendContent vs VotingContent).
// Cada una es responsable de su propia presentación.
const TrendingPage = () => {
  const [trendItem, setTrendItem] = useState(null);
  const [voteItem, setVoteItem] = useState(null);
  const [activeTab, setActiveTab] = useState("trend");
  const [loaded, setLoaded] = useState(false);
  const [searchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");

  useEffect(() => {
    fetch("/data/trending.json")
      .then((res) => res.json())
      .then((data) => {
        const activeItems = data.filter(isActive);
        const trend = activeItems.find(
          (t) => t.type === "trend" || t.type === "tweet"
        );
        const vote = activeItems.find((t) => t.type === "vote");
        setTrendItem(trend || null);
        setVoteItem(vote || null);
        if (requestedTab === "vote" && vote) setActiveTab("vote");
        else if (requestedTab === "trend" && trend) setActiveTab("trend");
        else setActiveTab(trend ? "trend" : "vote");
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const showTabs = trendItem && voteItem;

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {loaded && (
        <>
          {showTabs && (
            <div className="flex justify-center mb-5">
              <button
                onClick={() => setActiveTab("trend")}
                className={`px-4 py-2 rounded-l-full font-semibold transition-all duration-200 ${pillClasses(
                  activeTab === "trend"
                )}`}
              >
                🔥 Tendencia
              </button>
              <button
                onClick={() => setActiveTab("vote")}
                className={`px-4 py-2 rounded-r-full font-semibold transition-all duration-200 ${pillClasses(
                  activeTab === "vote"
                )}`}
              >
                🗳️ Votación
              </button>
            </div>
          )}

          {showTabs ? (
            activeTab === "trend" ? (
              <TrendContent item={trendItem} />
            ) : (
              <VotingContent item={voteItem} />
            )
          ) : voteItem ? (
            <VotingContent item={voteItem} />
          ) : (
            <TrendContent item={trendItem} />
          )}
        </>
      )}
    </div>
  );
};

export default TrendingPage;
